export default __webpack_public_path__ + "static/media/loder-prospectone.8d1df293.gif";